module.exports = __webpack_public_path__ + "media/assets/images/blog/integrare_microsoft_365-small-9c6b92aac3604fd59711358f9f2bb528.png";